import React from 'react';
import PropTypes from 'prop-types';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import Modal from '@deliveroo/consumer-component-library/components/Modal';

/**
 * A simple Modal dialog to display in situations when we can’t deliver to a
 * customer’s address, e.g. within a given brand.
 */
export default function UndeliverableModal({
  appElement,
  heading,
  body,
  closeButtonLabel,
  actionButtonLabel,
  isOpen,
  onClose,
}) {
  return (
    <Modal
      appElement={appElement}
      isOpen={isOpen}
      onClose={onClose}
      closeButtonLabel={closeButtonLabel}
      type="dialog"
      renderFooter={() => (
        <Button type="primary" isBlock onClick={onClose}>
          {actionButtonLabel}
        </Button>
      )}
    >
      <Heading level={4} size="small">
        {heading}
      </Heading>
      <P adjacentVerticalSpacing="medium">{body}</P>
    </Modal>
  );
}

UndeliverableModal.propTypes = {
  /**
   * Allows you to specify the portion of your app that should be hidden
   * (via aria-hidden) to prevent assistive technologies such as screenreaders
   * from reading content outside of the content of your modal.
   * Also added so that it renders properly in Lemon.
   */
  appElement: PropTypes.string,

  /**
   * Boolean controlling whether the Modal is open or not.
   */
  isOpen: PropTypes.bool.isRequired,

  /**
   * Event handler for when the Modal is closed, or the action button is pressed.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Label text for the close button (cross) for accessibility purposes.
   */
  closeButtonLabel: PropTypes.string.isRequired,

  /**
   * Label text for the main action button.
   */
  actionButtonLabel: PropTypes.string.isRequired,

  /**
   * Main heading text of the Modal.
   */
  heading: PropTypes.string.isRequired,

  /**
   * Body text of the Modal.
   */
  body: PropTypes.string.isRequired,
};

UndeliverableModal.defaultProps = {
  appElement: '#__next',
};
